import { render, staticRenderFns } from "./NotificationMarker.vue?vue&type=template&id=4c717107&scoped=true&"
import script from "./NotificationMarker.vue?vue&type=script&lang=js&"
export * from "./NotificationMarker.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMarker.vue?vue&type=style&index=0&id=4c717107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c717107",
  null
  
)

export default component.exports